import * as Yup from "yup";

export const tokenAuthenticationRequestSchema = Yup.object({
  token: Yup.string().required("Bitte übergeben Sie ein Token."),
});

export type TokenAuthenticationRequest = Yup.InferType<
  typeof tokenAuthenticationRequestSchema
>;
